import Loader from '@cpg-its/ads.common.loading-circle';
import React from 'react';
import { useSelector } from 'react-redux';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { NewHireProps } from '../../../models/arc-epi-props';
import { LabelAndValue } from '../../../../../global/components/data-display/label-value';
import { getFormattedDate } from '../../../../../global/helpers/date-helpers';
import { EmploymentState } from '../../employment/employment-model';

interface Props {	
	newHireProps: NewHireProps;
}
export function NewHireNonStipEmploymentCompensationReview(props: Props) {
	const { newHireProps } = props;
	
	const employmentState = useSelector<TcsmStates, EmploymentState>(state => state?.employmentState);
	const currentEmployment = employmentState?.nonStipendiaryEmployment;		

	if (!employmentState?.nonStipEmploymentLoaded) {
		return (<Loader />);
	}

	return (
		<>
			<DividerSection removeDivider>
				<LabelAndValue label={newHireProps?.nonStipStartDateLabel} value={getFormattedDate(currentEmployment?.hire_date)}
					tooltipMessage={newHireProps?.nonStipStartDateTooltip} />					
				<LabelAndValue label={newHireProps?.nonStipTerminationDateLabel} value={getFormattedDate(currentEmployment?.termination_date)}
					tooltipMessage={newHireProps?.nonStipTerminationDateTooltip} />
				<LabelAndValue label={newHireProps?.positionTitleLabel} value={currentEmployment?.position_titles[0]?.position_title}
					tooltipMessage={newHireProps?.positionTitleTooltip} />
				<LabelAndValue label={newHireProps?.positionStartDateLabel} value={getFormattedDate(currentEmployment?.position_titles[0]?.start_date)} />
				<LabelAndValue label={newHireProps?.positionEndDateLabel} value={getFormattedDate(currentEmployment?.position_titles[0]?.end_date)} />
				<LabelAndValue label={newHireProps?.publishedTitleLabel} value={currentEmployment?.position_titles[0]?.published_title} />				
			</DividerSection>			
		</>
	);
}